import { useEffect, useState } from 'react'
import { Alert, Button, Form, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { createEvent, deleteEvent, listEvents } from '../actions/eventActions'
import { EVENT_CREATE_CLEAR, EVENT_DELETE_CLEAR, EVENT_TYPES } from '../constants/eventConstant'
import Loader from './Loader'

const initialForm = {
    title: '',
    type: EVENT_TYPES[0],
    eventDate: '',
    location: '',
    body: ''
}

const formatEventDate = value => value
    ? new Intl.DateTimeFormat('ar-SA', {
        dateStyle: 'medium',
        timeStyle: 'short'
    }).format(new Date(value))
    : '-'

const EventAdminPanel = () => {
    const [formData, setFormData] = useState(initialForm)
    const dispatch = useDispatch()
    const { loading, error, message } = useSelector(state => state.newEvent)
    const { loading: loadingList, error: errorList, events } = useSelector(state => state.events)
    const { loading: loadingDelete, error: errorDelete, message: deleteMessage } = useSelector(state => state.removeEvent)

    const changeHandler = ({ target: { name, value } }) => {
        setFormData(prev => ({ ...prev, [name]: value }))
    }

    const submitHandler = e => {
        e.preventDefault()
        dispatch(createEvent(formData))
    }

    const deleteHandler = id => {
        const isConfirm = window.confirm('هل تريد حذف هذه الفعالية؟')
        if(isConfirm) dispatch(deleteEvent(id))
    }

    useEffect(() => {
        dispatch(listEvents())
    }, [dispatch, message, deleteMessage])

    useEffect(() => {
        if(message) setFormData(initialForm)
    }, [message])

    useEffect(() => () => {
        dispatch({ type: EVENT_CREATE_CLEAR })
        dispatch({ type: EVENT_DELETE_CLEAR })
    }, [dispatch])

    return (
        <div className='admin-events'>
            <Form className='admin-events__form' onSubmit={submitHandler}>
                <h3>إضافة فعالية</h3>
                {loading && <Loader />}
                {error && <Alert variant='danger'>{error}</Alert>}
                {message && <Alert variant='success'>{message}</Alert>}
                {errorDelete && <Alert variant='danger'>{errorDelete}</Alert>}
                {deleteMessage && <Alert variant='success'>{deleteMessage}</Alert>}

                <Form.Group>
                    <Form.Label>عنوان الفعالية</Form.Label>
                    <Form.Control
                        name='title'
                        value={formData.title}
                        type='text'
                        placeholder='مثال: اجتماع عائلة سعيد بن غنيم'
                        required
                        onChange={changeHandler}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>نوع الحدث</Form.Label>
                    <Form.Control
                        as='select'
                        name='type'
                        value={formData.type}
                        required
                        onChange={changeHandler}
                    >
                        {EVENT_TYPES.map(type => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                    </Form.Control>
                </Form.Group>

                <Form.Group>
                    <Form.Label>موعد الفعالية</Form.Label>
                    <Form.Control
                        name='eventDate'
                        value={formData.eventDate}
                        type='datetime-local'
                        required
                        onChange={changeHandler}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>المكان</Form.Label>
                    <Form.Control
                        name='location'
                        value={formData.location}
                        type='text'
                        placeholder='الموقع أو المدينة'
                        onChange={changeHandler}
                    />
                </Form.Group>

                <Form.Group>
                    <Form.Label>تفاصيل مختصرة</Form.Label>
                    <Form.Control
                        as='textarea'
                        rows={4}
                        name='body'
                        value={formData.body}
                        placeholder='أي تفاصيل يحتاجها أفراد العائلة'
                        onChange={changeHandler}
                    />
                </Form.Group>

                <Button variant='primary' type='submit' disabled={loading}>
                    حفظ الفعالية
                </Button>
            </Form>

            <div className='admin-events__list'>
                <h3>الفعاليات الحالية</h3>
                {loadingList || loadingDelete ? <Loader />
                    : errorList ? <Alert variant='warning'>{errorList}</Alert>
                        : events && <div className='users__table'>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>العنوان</th>
                                        <th>النوع</th>
                                        <th>الموعد</th>
                                        <th>المكان</th>
                                        <th>حذف</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {events.map(event => (
                                        <tr key={event._id}>
                                            <td>{event.title}</td>
                                            <td>{event.type}</td>
                                            <td>{formatEventDate(event.eventDate)}</td>
                                            <td>{event.location || '-'}</td>
                                            <td>
                                                <Button variant='danger' onClick={() => deleteHandler(event._id)}>
                                                    حذف
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>}
            </div>
        </div>
    )
}

export default EventAdminPanel
